import React from 'react';
import SingleConfigFieldOptions from '../../_partials/WidgetEditControls/SingleConfigFieldOptions';
import ConfigPopover from '../../_partials/ConfigPopover';

export interface Props {
  moduleId: number;
  onClose(): void;
}

const GroupsConfigPopover: React.FC<Props> = ({ moduleId, onClose }) => (
  <ConfigPopover onClose={onClose}>
    <SingleConfigFieldOptions
      moduleId={moduleId}
      paramName="sortBy"
      labels={{
        newest: 'common.sortOrder.newest',
        oldest: 'common.sortOrder.oldest',
        most_members: 'common.sortOrder.members',
        random: 'common.sortOrder.random',
      }}
      close={onClose}
    />
  </ConfigPopover>
);

GroupsConfigPopover.displayName = 'GroupsConfigPopover';

export default GroupsConfigPopover;
